export const HIDDEN_USERS_KEY = 'HB_HIDDEN_USERS';
export const USERS_LIST_STORAGE_KEY = 'HB_USERS_LIST_STORAGE_KEY';
